var map = {
	"./+.svg": 2586,
	"./bbc_logo.png": 1845,
	"./bbc_logo.svg": 1505,
	"./client_logo.png": 8567,
	"./favicon.png": 5170,
	"./icon.png": 1297,
	"./social.jpg": 798,
	"./socialtwitter.jpg": 8508
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3553;